import React, { useState, useEffect } from 'react';
import { MdArrowBack, MdAccountBalanceWallet, MdInfoOutline, MdLock } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { db } from "../firebase";
import { ref, onValue, push, serverTimestamp, update } from "firebase/database";
import Swal from 'sweetalert2';
import './Withdraw.css';

const Withdraw = () => {
    const [amount, setAmount] = useState('');
    const [balance, setBalance] = useState(0);
    const [boundWallet, setBoundWallet] = useState({
        name: "Not Bound",
        address: "Please bind a wallet first"
    });

    const navigate = useNavigate();
    const savedUser = JSON.parse(localStorage.getItem('user'));

    useEffect(() => {
        if (savedUser?.username) {
            const userRef = ref(db, `users/${savedUser.username}`);
            onValue(userRef, (snapshot) => {
                const data = snapshot.val();
                if (data) {
                    setBalance(parseFloat(data.balance) || 0);
                    if (data.paymentMethod) {
                        setBoundWallet({
                            name: data.paymentMethod.walletName,
                            address: data.paymentMethod.address
                        });
                    }
                }
            });
        }
    }, [savedUser?.username]);

    const handleBack = () => {
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate('/'); 
        }
    };

    const handleWithdraw = async () => {
        const val = parseFloat(amount);

        if (boundWallet.name === "Not Bound" || !boundWallet.address) {
            return Swal.fire('Error', 'Please bind your wallet in Payment Methods first', 'error');
        }

        if (!val || val < 10) {
            return Swal.fire({
                icon: 'warning',
                title: 'Minimum Amount',
                text: 'Minimum withdrawal is 10.00 USDT',
                confirmButtonColor: '#f3ba2f'
            });
        }

        if (val > balance) {
            return Swal.fire({
                icon: 'error',
                title: 'Insufficient Balance',
                text: 'You do not have enough funds.',
                confirmButtonColor: '#f3ba2f'
            });
        }

        Swal.fire({
            title: 'Processing...',
            text: 'Submitting your request...',
            allowOutsideClick: false,
            didOpen: () => { Swal.showLoading(); }
        });

        try {
            const newWithdrawRef = push(ref(db, 'withdrawals'));
            const requestId = newWithdrawRef.key;
            const newBalance = (balance - val).toFixed(2);

            // Transaction History Entry Logic
            const newTransactionRef = push(ref(db, 'transactions'));
            const transId = newTransactionRef.key;

            const updates = {};
            updates[`/users/${savedUser.username}/balance`] = newBalance;
            
            // 1. Withdrawals Node (Admin ke liye)
            updates[`/withdrawals/${requestId}`] = {
                username: savedUser.username,
                amount: val,
                walletName: boundWallet.name,
                address: boundWallet.address,
                status: 'pending',
                timestamp: serverTimestamp(),
                requestId: requestId
            };

            // 2. Transactions Node (User ki History ke liye)
            updates[`/transactions/${transId}`] = {
                username: savedUser.username,
                type: 'Withdraw',
                amount: val,
                status: 'Pending', // Audit hone tak pending show hoga
                timestamp: serverTimestamp(),
                details: `Withdrawal to ${boundWallet.name}`,
                requestId: requestId // Dono ko link kar diya taake update karne mein asani ho
            };

            await update(ref(db), updates);

            Swal.fire({
                icon: 'success',
                title: 'Request Submitted',
                text: 'Funds will arrive after audit.',
                timer: 2000,
                showConfirmButton: false
            });
            
            setTimeout(() => navigate('/'), 2000);
        } catch (error) {
            Swal.fire('Error', 'Failed: ' + error.message, 'error');
        }
    };

    return (
        <div className="withdraw-luxury-wrapper">
            <div className="withdraw-nav">
                <MdArrowBack onClick={handleBack} className="nav-icon" />
                <span>Withdraw USDT</span>
                <div className="nav-spacer"></div>
            </div>

            <div className="withdraw-container">
                <div className="balance-mini-card">
                    <p>Available Balance</p>
                    <h2>{balance.toFixed(2)} <span>USDT</span></h2>
                </div>

                <div className="wallet-bound-section">
                    <div className="section-label">
                        <span>Withdrawal Method</span>
                        <div className="lock-badge"><MdLock size={12}/> FIXED</div>
                    </div>
                    
                    <div className="bound-card">
                        <div className="wallet-info">
                            <div className="wallet-icon-circle">
                                <MdAccountBalanceWallet size={24} color="#f3ba2f" />
                            </div>
                            <div className="wallet-details">
                                <strong>{boundWallet.name}</strong>
                                <p style={{ wordBreak: 'break-all' }}>{boundWallet.address}</p>
                            </div>
                        </div>
                        <div className="network-tag">TRC20</div>
                    </div>
                    <p className="hint-text"><MdInfoOutline/> To change wallet, contact Customer Support.</p>
                </div>

                <div className="amount-input-section">
                    <label>Withdrawal Amount</label>
                    <div className="premium-input-box">
                        <input 
                            type="number" 
                            placeholder="Min 10.00" 
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                        />
                        <button onClick={() => setAmount(balance.toString())} className="all-btn">ALL</button>
                    </div>
                    <div className="fee-info">
                        <span>Service Fee: 3%</span>
                        <span>Will receive: ${amount ? (parseFloat(amount) * 0.97).toFixed(2) : "0.00"}</span>
                    </div>
                </div>

                <div className="warning-notice">
                    <ul>
                        <li>Audit usually takes 5-30 minutes.</li>
                        <li>Please ensure the network (TRC20) is correct.</li>
                    </ul>
                </div>

                <button className="withdraw-submit-btn" onClick={handleWithdraw}>
                    CONFIRM WITHDRAWAL
                </button>
            </div>
        </div>
    );
};

export default Withdraw;